import { inject, Injectable, Type } from '@angular/core';
import { FpCorrelationTabs } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/enums/fp-correlation-tabs.enum';
import { IFpCorrelationData } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-data';
import { IFpCorrelationTabConnectService } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/interfaces/fp-correlation-tab-connect-service';
import { FpCorrelationSummaryComponent } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-summary/components/fp-correlation-summary/fp-correlation-summary.component';
import { FpCorrelationSummaryActionType } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-summary/services/fp-correlation-summary/fp-correlation-summary.actions';
import { FpCorrelationSummaryStore } from '@app/main/leak-detection/floating-popups/floating-popup-correlation/tabs/fp-correlation-summary/services/fp-correlation-summary/fp-correlation-summary.store';
import { Observable } from 'rxjs';

@Injectable()
export class FpCorrelationSummaryConnectService implements IFpCorrelationTabConnectService {
  protected tabStore = inject(FpCorrelationSummaryStore);
  public currentTab = FpCorrelationTabs.Summary;

  public component: Type<unknown> = FpCorrelationSummaryComponent;
  public minimizedComponent: Type<unknown> = FpCorrelationSummaryComponent;

  public localLoading(): Observable<boolean> {
    return this.tabStore.loading$;
  }

  public isActive(tab: FpCorrelationTabs) {
    return this.currentTab === tab;
  }

  public initData(selectedDate: string, selectedData: IFpCorrelationData) {
    this.tabStore.dispatch({
      type: FpCorrelationSummaryActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }

  public updateData(selectedDate: string, selectedData: IFpCorrelationData) {
    this.tabStore.dispatch({
      type: FpCorrelationSummaryActionType.GetData,
      date: selectedDate,
      popupMainData: selectedData,
    });
  }
}
